import dayjs from "dayjs";

/**
 * 掲載終了までの日数を返す文字列
 * @param {string | Date} endDate
 * @returns {string}
 */
export const remainingDays = (endDate) => {
  if (!endDate) return "";

  const today = dayjs().startOf("day");
  const end = dayjs(endDate).startOf("day");
  const diff = end.diff(today, "day");

  if (diff < 0) return "掲載終了済み";
  if (diff === 0) return "本日掲載終了";
  return `掲載終了まであと${diff}日`;
};

/**
 * 日本のロケール（ja-JP）で日付と時刻をフォーマット
 *
 * @param {string|Date} dateString - 日付の文字列またはDateオブジェクト
 * @returns {string} フォーマットされた日付文字列（例: "2025/06/25 14:30"）
 */
export const formatJpDateTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

/**
 * 日本のロケール（ja-JP）で日付のみをフォーマット
 * @param {string|Date} dateString- 日付の文字列またはDateオブジェクト
 * @returns {string}フォーマットされた日付文字列（例: "2025/06/25"）
 */
export const formatJpDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
